






















import Vue from 'vue';
import { Component, Prop, Ref } from 'vue-property-decorator';
import { waitForHydration, waitForRef } from '@/helpers/async-helper';

@Component({
	name: 'DynamicVirtualScroller',
})
export default class DynamicVirtualScroller<Item> extends Vue {
	private destroyed = false;
	IS_SERVER = !!process.server;

	@Prop({ default: true }) enabled: boolean;
	@Prop() items: Item[];
	@Prop({ default: 'id' }) keyField: string;

	@Ref('dynamic-scroller') dynamicScroller?: any;

	beforeDestroy() {
		// TODO: also remove listener added at `this.setContent` (most likely by a helper that holds all necessary references)
		this.destroyed = true;
	}

	mounted() {
		if (!this.enabled) return;
		const content = this.$el.closest('ion-content');
		if (!content) {
			console.error('<DynamicVirtualScroller> must be used inside an <ion-content>');
			return;
		}

		this.setContent(content);
	}

	async setContent(content: any) {
		if (!this.enabled || this.destroyed) return;
		await waitForHydration(content);
		const scrollElement = await content.getScrollElement();
		await waitForRef(this, 'dynamic-scroller');

		if (this.dynamicScroller) {
			await waitForRef(this.dynamicScroller, 'scroller');
			this.dynamicScroller.$refs.scroller.listenerTarget = scrollElement;
			scrollElement.addEventListener('scroll', this.dynamicScroller.$refs.scroller.handleScroll);
			scrollElement.addEventListener('resize', this.dynamicScroller.$refs.scroller.handleResize);
		}
	}
}
